import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import {
  AttachRegular,
  Delete24Regular,
  Eye24Regular,
  MoreVerticalRegular,
} from "@fluentui/react-icons";
import {
  Button,
  makeStyles,
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Skeleton,
  SkeletonItem,
  Tooltip,
  typographyStyles,
} from "@fluentui/react-components";
import ViewMessage from "./viewMessage";
import moment from "moment";
import { getTimeDifference } from "../../../../utils";
import {
  deleteMessage,
  fetchCustomerMessages,
  patchMessage,
} from "../../../../redux/clientPortal/clientPortalslice";
import PortalDeletePopup from "../../../../components/DeletePopup/portalDeletePopup";

const useStyles = makeStyles({
  text: { ...typographyStyles.subtitle2, color: "red" },
  name: { ...typographyStyles.subtitle1 },
  subject: {
    ...typographyStyles.subtitle2,
    whiteSpace: "nowrap",
  },
  message: { ...typographyStyles.body1 },
});

export default function ReceivedMessage({
  customerId,
  notify,
  receivedMessages,
}: any) {
  const styles = useStyles();
  const dispatch = useDispatch<AppDispatch>();
  const [openMessage, setOpenMessage] = useState<boolean>(false);
  const [deletePopupOpen, setDeletePopupOpen] = useState(false);
  const [currentMessageId, setCurrentMessageId] = useState<string | null>(null);
  const [messageDetails, setMessageDetails] = useState<any>({});
  const [actionProcessing, setActionProcessing] = useState(false);
  const { loading } = useSelector((state: RootState) => state.portal);
  console.log("loading", loading);
  const handleView = (messageId: string, msg: any) => {
    if (messageId) {
      setMessageDetails({
        ...msg,
      });
      setOpenMessage(true); // Ensure this is executing

      if (!msg.Read) {
        dispatch(patchMessage(messageId))
          .unwrap()
          .then(() => {
            if (customerId) {
              dispatch(fetchCustomerMessages({ customerId }));
            }
          })
          .catch((error: any) => {
            console.error("Error updating message:", error);
          });
      }
    }
  };
  const handleDelete = useCallback((messageId: string) => {
    setCurrentMessageId(messageId);
    setDeletePopupOpen(true);
  }, []);

  const handleConfirmDelete = useCallback(() => {
    setActionProcessing(true);

    if (currentMessageId) {
      dispatch(deleteMessage(currentMessageId))
        .then((res) => {
          notify(res.payload.message, "", "success");
          if (customerId) {
            dispatch(fetchCustomerMessages({ customerId }));
          }
          setActionProcessing(false);
        })
        .catch((err) => {
          console.error("Error deleting message:", err);
          setActionProcessing(false);
        });
      setDeletePopupOpen(false);
      setCurrentMessageId(null);
    }
  }, [dispatch, customerId, currentMessageId]);

  return (
    <>
      {loading ? (
        Array.from({ length: 5 }).map((__, index) => (
          <div key={index} className="invertedWrapper">
            <Skeleton
              style={{ width: "100%" }}
              className=""
              appearance="translucent"
            >
              <SkeletonItem
                style={{ width: "15%", height: "20px", margin: "5px 0" }}
              />
              <SkeletonItem
                style={{ width: "100%", height: "20px", margin: "5px 0" }}
              />
              <SkeletonItem
                style={{ width: "40%", height: "20px", margin: "5px 0" }}
              />
            </Skeleton>
          </div>
        ))
      ) : receivedMessages?.length ? (
        receivedMessages.map((msg: any) => {
          const formattedTooltip = moment(msg.CreatedAt).format(
            "DD/MM/YYYY HH:mm a"
          );
          const relativeTime = getTimeDifference(msg.CreatedAt);
          return (
            <div
              key={msg.MessageId}
              onClick={() => {
                handleView(msg.MessageId, msg);
              }}
            >
              <div
                className="msg_box"
                style={{ color: msg.Read ? "#000000a6" : "#000" }}
              >
                <div className="w-full">
                  <div className="justify_between">
                    <p className={`${styles.subject} lineClamp`}>
                      {msg.Subject}
                    </p>

                    <Tooltip
                      withArrow
                      appearance="inverted"
                      positioning={"below"}
                      content={formattedTooltip}
                      relationship="label"
                    >
                      <p className={styles.message}>{relativeTime}</p>
                    </Tooltip>
                  </div>
                  <div>
                    <p className={`${styles.message} lineClamp`}>
                      {msg.Message}
                    </p>
                  </div>
                </div>
                <div className="justify_between">
                  {msg.attachments && msg.attachments.length > 0 && (
                    <AttachRegular fontSize="24px" />
                  )}
                  <Menu>
                    <MenuTrigger disableButtonEnhancement>
                      <Button
                        appearance="subtle"
                        icon={<MoreVerticalRegular />}
                        onClick={(event) => {
                          event.stopPropagation();
                          setCurrentMessageId(msg.messageId);
                        }}
                      />
                    </MenuTrigger>
                    <MenuPopover>
                      <MenuList>
                        <MenuItem
                          icon={<Eye24Regular />}
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent parent div click
                            handleView(msg.MessageId, msg);
                          }}
                        >
                          View
                        </MenuItem>
                        {/* <MenuItem
                          icon={<Delete24Regular />}
                          onClick={(event: React.MouseEvent) => {
                            event.stopPropagation();
                            handleDelete(msg.MessageId);
                          }}
                        >
                          Delete
                        </MenuItem> */}
                      </MenuList>
                    </MenuPopover>
                  </Menu>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div className="data_body no_data">
          <p className={styles.text}>There are no messages</p>
        </div>
      )}

      <ViewMessage
        open={openMessage}
        onClose={() => setOpenMessage(false)}
        messageDetails={messageDetails}
        customerId={customerId}
      />
      <PortalDeletePopup
        open={deletePopupOpen}
        onClose={() => setDeletePopupOpen(false)}
        onConfirmDelete={handleConfirmDelete}
        actionProcessing={actionProcessing}
      />
    </>
  );
}
